module.exports = __webpack_public_path__ + "media/application/images/ui/tick-5f641b16e4ef298666c549a26ff8df42.png";